import React, { useState, useCallback } from 'react';

const GOLD = '#C9A84C';
const DARK = '#1a1a2e';

export default function TrialExpiredScreen() {
  const [step, setStep] = useState('initial');

  const handleSubscribe = useCallback(() => {
    window.location.href = '/subscribe';
  }, []);

  const handleSignOut = useCallback(() => {
    setStep('leaving');
    try { localStorage.clear(); } catch {}
    setTimeout(() => { window.location.href = '/'; }, 1500);
  }, []);

  const overlay = {
    position: 'fixed',
    inset: 0,
    zIndex: 99999,
    background: 'rgba(0,0,0,0.85)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  };

  const card = {
    maxWidth: 440,
    width: '100%',
    background: 'var(--bg-primary, #121212)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 20,
    padding: 32,
    textAlign: 'center',
    boxShadow: '0 24px 80px rgba(0,0,0,0.6)',
  };

  if (step === 'leaving') {
    return (
      <div style={overlay}>
        <div style={card}>
          <div style={{
            width: 40, height: 40,
            border: '3px solid rgba(201,168,76,0.2)',
            borderTopColor: GOLD,
            borderRadius: '50%',
            animation: 'spin 0.8s linear infinite',
            margin: '0 auto 20px',
          }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#fff' }}>Signing out...</h2>
        </div>
      </div>
    );
  }

  return (
    <div style={overlay}>
      <div style={card}>
        <div style={{
          width: 56, height: 56, borderRadius: '50%',
          background: 'rgba(201,168,76,0.12)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px',
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={GOLD} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
          </svg>
        </div>

        <h2 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text-primary, #fff)', marginBottom: 10 }}>
          Your Free Trial Has Ended
        </h2>

        <p style={{ fontSize: 15, color: 'var(--text-secondary, rgba(255,255,255,0.55))', lineHeight: 1.6, marginBottom: 12 }}>
          Your playlists, favorites, and listening history are still safe.
          Subscribe now to keep everything and pick up right where you left off.
        </p>

        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.35)', lineHeight: 1.5, marginBottom: 28 }}>
          If you don't subscribe within 7 days, your account and data will be removed.
        </p>

        <button
          onClick={handleSubscribe}
          style={{
            width: '100%',
            fontSize: 15,
            fontWeight: 700,
            padding: '14px 0',
            borderRadius: 50,
            background: GOLD,
            color: DARK,
            cursor: 'pointer',
            border: 'none',
            marginBottom: 12,
            transition: 'opacity 0.15s',
          }}
        >
          Subscribe to Maestro &rarr;
        </button>

        <button
          onClick={handleSignOut}
          style={{
            width: '100%',
            fontSize: 14,
            fontWeight: 500,
            padding: 0,
            background: 'none',
            color: 'rgba(255,255,255,0.4)',
            cursor: 'pointer',
            border: 'none',
            textDecoration: 'underline',
            textUnderlineOffset: '3px',
          }}
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
